import type { HookFieldGetList_ReturnType } from "../../../../../../../_ovlclient/src/global/hooks"
import type { LookupsType } from "../../../../../../../_ovlclient/src/library/table/table"
import type { OfferingStatus } from "../../../screens/qutoffering/offering/helpers"

export type OfferingCalcOrderRow = {
  DocEntry: number
  DocNum: number
  Comments: string
  DocStatus: string
  DocDueDate: string
  ActualOffers: number[]
  TargetOffers: number[]
  TargetSummaryPos: number
  TargetSummaryQuantity: number
  TargetSummaryM3: number
  TargetSummaryM1: number
  ActualSummaryPos: number
  ActualSummaryQuantity: number
  ActualSummaryM3: number
  ActualSummaryM1: number
}

export type OfferingTool = {
  offerMainType: "CAD" | "CUT"
  lastProgressStatus: OfferingStatus
  selectedOfferKey: any
  adminResumeDocEntry: number
  selectedOfferType: string
  lookups: LookupsType
  detailsChanged: string
  cutPositionsChanged: boolean
  cutFileName: string
  cutListDirty: boolean
  detailsMaterialChanged: boolean
  detailsTransportChanged: boolean
  detailsCostChanged: boolean
  imageLoaded: string
  adminSalesCalcResult: OfferingCalcOrderRow[]
}

let lookups = {
  U_ItemCode: <HookFieldGetList_ReturnType>{
    data: {},
    lookupDef: {},
  },
}

export let QUTOffering: OfferingTool = {
  offerMainType: undefined,
  lastProgressStatus: undefined,
  selectedOfferKey: undefined,
  adminResumeDocEntry: undefined,
  selectedOfferType: undefined,
  lookups,
  detailsChanged: undefined,
  detailsMaterialChanged: false,
  cutPositionsChanged: false,
  cutFileName: "",
  cutListDirty: false,
  detailsTransportChanged: false,
  detailsCostChanged: false,
  imageLoaded: "",
  adminSalesCalcResult: undefined,
}
